'use strict';

var utils = require('../../utils.js');

var text = {
  // heading-3xl
  'text-heading-3xl-font-family': {
    value: utils.createVar('font-family-sans')
  },
  'text-heading-3xl-font-size': {
    value: utils.createVar('font-size-900')
  },
  'text-heading-3xl-font-weight': {
    value: utils.createVar('font-weight-bold')
  },
  'text-heading-3xl-font-letter-spacing': {
    value: utils.createVar('font-letter-spacing-densest')
  },
  'text-heading-3xl-font-line-height': {
    value: utils.createVar('font-line-height-1200')
  },
  // heading-2xl
  'text-heading-2xl-font-family': {
    value: utils.createVar('font-family-sans')
  },
  'text-heading-2xl-font-size': {
    value: utils.createVar('font-size-750')
  },
  'text-heading-2xl-font-weight': {
    value: utils.createVar('font-weight-bold')
  },
  'text-heading-2xl-font-letter-spacing': {
    value: utils.createVar('font-letter-spacing-denser')
  },
  'text-heading-2xl-font-line-height': {
    value: utils.createVar('font-line-height-1000')
  },
  // heading-xl
  'text-heading-xl-font-family': {
    value: utils.createVar('font-family-sans')
  },
  'text-heading-xl-font-size': {
    value: utils.createVar('font-size-600')
  },
  'text-heading-xl-font-weight': {
    value: utils.createVar('font-weight-bold')
  },
  'text-heading-xl-font-letter-spacing': {
    value: utils.createVar('font-letter-spacing-dense')
  },
  'text-heading-xl-font-line-height': {
    value: utils.createVar('font-line-height-800')
  },
  // heading-lg
  'text-heading-lg-font-family': {
    value: utils.createVar('font-family-sans')
  },
  'text-heading-lg-font-size': {
    value: utils.createVar('font-size-500')
  },
  'text-heading-lg-font-weight': {
    value: utils.createVar('font-weight-semibold')
  },
  'text-heading-lg-font-letter-spacing': {
    value: utils.createVar('font-letter-spacing-dense')
  },
  'text-heading-lg-font-line-height': {
    value: utils.createVar('font-line-height-600')
  },
  // heading-md
  'text-heading-md-font-family': {
    value: utils.createVar('font-family-sans')
  },
  'text-heading-md-font-size': {
    value: utils.createVar('font-size-350')
  },
  'text-heading-md-font-weight': {
    value: utils.createVar('font-weight-semibold')
  },
  'text-heading-md-font-letter-spacing': {
    value: utils.createVar('font-letter-spacing-normal')
  },
  'text-heading-md-font-line-height': {
    value: utils.createVar('font-line-height-500')
  },
  // heading-sm
  'text-heading-sm-font-family': {
    value: utils.createVar('font-family-sans')
  },
  'text-heading-sm-font-size': {
    value: utils.createVar('font-size-325')
  },
  'text-heading-sm-font-weight': {
    value: utils.createVar('font-weight-semibold')
  },
  'text-heading-sm-font-letter-spacing': {
    value: utils.createVar('font-letter-spacing-normal')
  },
  'text-heading-sm-font-line-height': {
    value: utils.createVar('font-line-height-500')
  },
  // heading-xs
  'text-heading-xs-font-family': {
    value: utils.createVar('font-family-sans')
  },
  'text-heading-xs-font-size': {
    value: utils.createVar('font-size-300')
  },
  'text-heading-xs-font-weight': {
    value: utils.createVar('font-weight-semibold')
  },
  'text-heading-xs-font-letter-spacing': {
    value: utils.createVar('font-letter-spacing-normal')
  },
  'text-heading-xs-font-line-height': {
    value: utils.createVar('font-line-height-400')
  },
  // body-lg
  'text-body-lg-font-family': {
    value: utils.createVar('font-family-sans')
  },
  'text-body-lg-font-size': {
    value: utils.createVar('font-size-350')
  },
  'text-body-lg-font-weight': {
    value: utils.createVar('font-weight-regular')
  },
  'text-body-lg-font-letter-spacing': {
    value: utils.createVar('font-letter-spacing-normal')
  },
  'text-body-lg-font-line-height': {
    value: utils.createVar('font-line-height-500')
  },
  // body-md
  'text-body-md-font-family': {
    value: utils.createVar('font-family-sans')
  },
  'text-body-md-font-size': {
    value: utils.createVar('font-size-325')
  },
  'text-body-md-font-weight': {
    value: utils.createVar('font-weight-regular')
  },
  'text-body-md-font-letter-spacing': {
    value: utils.createVar('font-letter-spacing-normal')
  },
  'text-body-md-font-line-height': {
    value: utils.createVar('font-line-height-500')
  },
  // body-sm
  'text-body-sm-font-family': {
    value: utils.createVar('font-family-sans')
  },
  'text-body-sm-font-size': {
    value: utils.createVar('font-size-300')
  },
  'text-body-sm-font-weight': {
    value: utils.createVar('font-weight-regular')
  },
  'text-body-sm-font-letter-spacing': {
    value: utils.createVar('font-letter-spacing-normal')
  },
  'text-body-sm-font-line-height': {
    value: utils.createVar('font-line-height-400')
  },
  // body-xs
  'text-body-xs-font-family': {
    value: utils.createVar('font-family-sans')
  },
  'text-body-xs-font-size': {
    value: utils.createVar('font-size-275')
  },
  'text-body-xs-font-weight': {
    value: utils.createVar('font-weight-regular')
  },
  'text-body-xs-font-letter-spacing': {
    value: utils.createVar('font-letter-spacing-normal')
  },
  'text-body-xs-font-line-height': {
    value: utils.createVar('font-line-height-300')
  }
};

exports.text = text;
